import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { EndpointsPage } from '@/features/admin/endpoints/endpoint-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Endpoints de serving d'un projet (porting README #52). La page courante vit dans l'URL (`?page=`), la première ne l'écrit pas. */
export const Route = createFileRoute('/$tenant/projects/$projectId/endpoints/')({
  validateSearch: (search: Record<string, unknown>): { page?: number } => {
    const page = Number(search['page']);
    return Number.isInteger(page) && page > 0 ? { page } : {};
  },
  component: EndpointsRoute,
});

function EndpointsRoute() {
  const { tenant, projectId } = Route.useParams();
  const { page = 0 } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="endpoints"
      crumbs={[{ label: t('nav.items.endpoints') }]}
    >
      <EndpointsPage
        tenantId={tenant}
        projectId={projectId}
        page={page}
        onPageChange={(next) => void navigate({ search: next > 0 ? { page: next } : {}, replace: true })}
      />
    </ConsoleShell>
  );
}
